// src/App.js
import React from "react";
import Home from "./HomePage";

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
